import { useQuery } from 'react-query';
import { ParticipantService } from '../../../services/v1/interview_intelligence/ParticipantService';

export const useSpeakers = (interviewId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['speakers', interviewId, { expand: expand }],
    queryFn: () => ParticipantService.list(interviewId, true, expand),
  });
